import { Brain, RefreshCw, Headphones, BookOpen } from "lucide-react";

const reasons = [
  {
    icon: Brain,
    title: "Personalized = More Attention",
    description: "When children hear their own name, they pay 3x more attention to the story.",
    emoji: "🧠",
    color: "text-[hsl(var(--playful-orange))]",
    bgColor: "bg-[hsl(var(--playful-orange),0.1)]",
  },
  {
    icon: RefreshCw,
    title: "Repetition Builds Learning",
    description: "Kids love hearing stories again. Each time reinforces the lesson naturally.",
    emoji: "🔄",
    color: "text-[hsl(var(--playful-pink))]",
    bgColor: "bg-[hsl(var(--playful-pink),0.1)]",
  },
  {
    icon: Headphones,
    title: "Audio Sparks Imagination",
    description: "Without visuals, children create their own mental pictures — building creativity.",
    emoji: "🎧",
    color: "text-[hsl(var(--playful-purple))]",
    bgColor: "bg-[hsl(var(--playful-purple),0.1)]",
  },
  {
    icon: BookOpen,
    title: "Stories Teach Values",
    description: "Values learned through stories stick better than direct instructions.",
    emoji: "📖",
    color: "text-[hsl(var(--playful-teal))]",
    bgColor: "bg-[hsl(var(--playful-teal),0.1)]",
  },
];

const WhyAISection = () => {
  return (
    <section className="py-16 md:py-24 px-4 bg-gradient-to-b from-background to-[hsl(var(--playful-teal),0.05)]">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1 bg-[hsl(var(--playful-purple),0.2)] text-[hsl(var(--playful-purple))] rounded-full text-sm font-medium mb-4">
            🎓 The Science Behind It
          </span>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">
            Why{" "}
            <span className="bg-gradient-to-r from-[hsl(var(--playful-purple))] to-[hsl(var(--playful-teal))] bg-clip-text text-transparent">
              Personalized Stories
            </span>{" "}
            Work
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Backed by child development research — here's why this approach is so effective.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className={`${reason.bgColor} rounded-3xl p-6 border border-border/50 hover:shadow-lg transition-all duration-300 group`}
            >
              <div className="flex items-start gap-4">
                <div className={`w-14 h-14 ${reason.bgColor} rounded-2xl flex items-center justify-center border border-border/50 group-hover:animate-bounce-gentle`}>
                  <span className="text-2xl">{reason.emoji}</span>
                </div>
                <div className="flex-1">
                  <h3 className="font-display text-lg font-bold text-foreground mb-2">
                    {reason.title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {reason.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyAISection;
